import type { Need, Skill, SkillCategory } from '@lmc/ts-common'
import type { TFunction } from 'i18next'

export const getValidity = (
  t: TFunction<string, undefined>,
  trainingValidFor?: number
) =>
  trainingValidFor
    ? `${trainingValidFor} ${t(`skillsAndNeeds.form.months`)}`
    : null

export const getSkill = (id: string, skillOptions: Skill[]) =>
  skillOptions?.find((skill) => skill.id === id)?.name

export const getNeeds = (ids: string[], needOptions: Need[] | undefined) => {
  const tempNeedNames: string[] = []

  ids?.forEach((id) => {
    if (needOptions?.length) {
      tempNeedNames.push(
        needOptions?.find((need) => need.id === id)?.name as string
      )
    }
  })

  return tempNeedNames.join(', ')
}

export const getCategories = (
  ids: string[],
  categoriesOptions: SkillCategory[]
) => {
  const tempCategoryNames: string[] = []

  ids?.forEach((id) => {
    const category = categoriesOptions?.find((category) => category.id === id)

    if (category?.name) {
      tempCategoryNames.push(category.name as string)
    }
  })

  return tempCategoryNames.join(', ')
}
